// import React, { Component } from "react";
// import { connect } from "react-redux";
// import { NotificationManager } from "react-notifications";
// import { GetUserLogin, GetOrderDetails, CartHelper } from "../../../services";
// import {
//   removeFromCart,
//   incrementToCart,
//   decreaseToCart,
// } from "../../../../store/actions/cartActions";
// import Addressdetails from "./address";
// import Loading from "react-fullscreen-loading";

// class Checkout extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       isLoaded: false,
//       subTotal: 0,
//       discount: 0,
//       deliveryCharge: 0,
//       grandTotal: 0,
//       email: "",
//       customer: "",
//       deliveryAddress: "",
//       currentStep: 1,
//     };
//   }

//   handleRadioChange = (e) => {
//     this.setState({ [e.target.name]: e.target.value });
//   };

//   handleDeliveryAddress = (value) => {
//     this.setState({ deliveryAddress: value, currentStep: 3 }); // Move to payment step after selecting delivery address
//   };

//   async componentDidMount() {
//     // 🚫 If no cart items, redirect to home or cart
//     if (!this.props.cartItems || this.props.cartItems.length === 0) {
//       window.location.href = "/"; // Or "/cart"
//       return;
//     }

//     let email = sessionStorage.getItem("email");
//     if (email) {
//       let user = await GetUserLogin.getCustomerDetail(email);
//       if (user) {
//         this.setState({ customer: user.data, email: email, currentStep: 2 }); // Open delivery section after login
//       }
//     }

//     // let cart = this.props.cartItems;
//     let subTotal = this.calculateSubTotal();
//     let discount = subTotal > 200 ? subTotal * 0.1 : 0; // 10% discount if subtotal is greater than 200
//     let deliveryCharge = subTotal * 0.05;
//     let grandTotal = subTotal - discount + deliveryCharge;

//     this.setState({ subTotal, discount, deliveryCharge, grandTotal });
//   }

//   handlePaymentSystem = async (e) => {
//     e.preventDefault();
//     this.setState({ isLoaded: true });

//     const { customer, deliveryAddress } = this.state;
//     const { cartItems } = this.props;

//     if (deliveryAddress) {
//       const grandTotal = this.calculateGrandTotal(cartItems);
//       const products = this.prepareProducts(cartItems);
//       const addressId = deliveryAddress.selectedAddress || null;

//       try {
//         // Step 1: Create Razorpay order on backend
//         const razorpayOrderResponse = await GetOrderDetails.RazorpayOrder({
//           cartItems,
//         });

//         if (!razorpayOrderResponse || !razorpayOrderResponse.orderId) {
//           NotificationManager.error("Failed to create Razorpay order", "Error");
//           this.setState({ isLoaded: false });
//           return;
//         }

//         const { orderId, data } = razorpayOrderResponse;

//         const razorpayAmount = data?.data?.amount;

//         // Step 2: Prepare preorder data using the order ID
//         const preorderData = {
//           customerId: customer.id,
//           orderId,
//           grandTotal: razorpayAmount / 100,
//           products: products,
//           addressId: addressId,
//           deliveryAddress: deliveryAddress,
//         };

//         // Step 3: Create the preorder with the obtained order ID
//         await this.createPreorder(preorderData);

//         const backendAmount = razorpayAmount / 100; // Convert paise to rupees
//         // Step 4: Prepare Razorpay payment options
//         const options = this.getRazorpayOptions(
//           customer,
//           orderId,
//           addressId,
//           deliveryAddress,
//           products,
//           backendAmount
//         );

//         const paymentObject = new window.Razorpay(options);
//         paymentObject.open();

//         paymentObject.on("close", () => {
//           this.setState({ isLoaded: false });
//         });
//       } catch (err) {
//         console.error("Error during payment processing:", err);
//         NotificationManager.error("Payment processing failed", "Error");
//         this.setState({ isLoaded: false });
//       }
//     } else {
//       NotificationManager.error("Please check address details", "Input Field");
//       this.setState({ isLoaded: false });
//     }
//   };

//   calculateGrandTotal = (cartItems) => {
//     const subTotal = this.calculateSubTotal(cartItems);
//     const discount = subTotal > 200 ? subTotal * 0.1 : 0;
//     const deliveryCharge = 0;
//     return subTotal - discount + deliveryCharge;
//   };

//   prepareProducts = (cartItems) => {
//     return cartItems.map((item) => {
//       const variantIds = item.selectedVariants.map((variant) => variant.id);
//       return {
//         productId: item.id,
//         variantIds: variantIds,
//       };
//     });
//   };

//   createPreorder = async (preorderData) => {
//     return await GetOrderDetails.createPreorder(preorderData);
//   };

//   createRazorpayOrder = async (grandTotal) => {
//     return await GetOrderDetails.RazorpayOrder(grandTotal);
//   };

//  getRazorpayOptions = (
//   customer,
//   orderId,
//   addressId,
//   deliveryAddress,
//   products,
//   backendAmount
// ) => {
//   const productDescription = products?.map((p) => {
//     const product = this.props.cartItems.find(
//       (item) => item.id === p.productId
//     );
//     const variantNames = product.selectedVariants
//       .map((v) => v.name)
//       .join(", ");
//     return `${product.name} [${variantNames}]`;
//   }).join(" | ");

//   return {
//     key: "rzp_live_YJ7vOnVL1HKfgL",
//     currency: "INR",
//     name: "JC Creations",
//     description: "JC Creations Order",
//     notes: { order_description: productDescription },
//     image: "img/JC-logo.png",
//     prefill: {
//       name: customer.fullName,
//       email: customer.email,
//       contact: customer.phone || "",
//     },
//     theme: { color: "#F37254" },
//     order_id: orderId,
//     handler: async (response) => {
//       if (response.razorpay_payment_id) {
//         await this.handlePaymentCapture(
//           response.razorpay_payment_id,
//           backendAmount,
//           customer,
//           orderId,
//           addressId,
//           deliveryAddress,
//           products
//         );
//       }
//     },
//     modal: {
//       ondismiss: () => this.setState({ isLoaded: false }),
//     },
//   };
// };

//   handlePaymentCapture = async (
//     razorpayPaymentId,
//     backendAmount,
//     customer,
//     orderId,
//     addressId,
//     deliveryAddress,
//     products
//   ) => {
//     try {
//       const Paymentdata = { razorpayPaymentId, backendAmount };

//       try {
//         await GetOrderDetails.capturePayment(Paymentdata);
//       } catch (captureError) {
//         console.warn(
//           "Payment capture failed, proceeding with order creation:",
//           captureError
//         );
//       }

//       // Step 2: Create the order
//       const orderData = {
//         customerId: customer.id,
//         orderId: orderId,
//         addressId: addressId,
//         deliveryAddress: deliveryAddress,
//         grandTotal: backendAmount,
//         razorpayPaymentId: razorpayPaymentId,
//         products: products,
//       };

//       let order = await GetOrderDetails.getOrderCreateByUser(orderData);

//       if (order) {
//         // Step 3: Send order confirmation email with order and customer details
//         // const confirmationData = {
//         //   orderId: order.orderId,
//         //   customerId: customer.id,
//         // };

//         // try {
//         //   await GetOrderDetails.sendOrderEmail(confirmationData);
//         //   NotificationManager.success("Successfully Ordered", "Order");
//         // } catch (emailError) {
//         //   console.error("Failed to send order confirmation email:", emailError);
//         // }

//         setTimeout(() => {
//           CartHelper.emptyCart();
//         }, 1000);
//       } else {
//         window.location.href = "/order/failed";
//       }
//     } catch (err) {
//       console.error("Error during payment or order creation:", err);
//       NotificationManager.error("Order creation failed", "Error");
//     } finally {
//       this.setState({ isLoaded: false });
//     }
//   };

//   handleRemoveProduct = (productId) => {
//     this.props.removeFromCart(productId, null);
//   };

//   calculateSubTotal = () => {
//     return this.props.cartItems.reduce((sum, item) => {
//       if (Array.isArray(item.selectedVariants)) {
//         return (
//           sum +
//           item.selectedVariants.reduce((variantSum, variant) => {
//             return (
//               variantSum +
//               (typeof variant.price === "number" ? variant.price : 0)
//             );
//           }, 0)
//         );
//       }
//       return sum;
//     }, 0);
//   };

//   render() {
//     const { cartItems } = this.props;
//     const { discount, email, customer, currentStep, isLoaded } = this.state;

//     const subTotal = this.calculateSubTotal();
//     const deliveryCharges = subTotal * 0.0;
//     const total = subTotal - discount + deliveryCharges;

//     return (
//       <div>
//         <section className="pt-3 pb-3 page-info section-padding border-bottom bg-white single-product-header-bk">
//           <div className="container">
//             <div className="row">
//               <div className="col-md-12">
//                 <a href="/">
//                   <strong>
//                     <span className="mdi mdi-home"></span> Home
//                   </strong>
//                 </a>{" "}
//                 <span className="mdi mdi-chevron-right"></span>{" "}
//                 <a
//                   href="/"
//                   onClick={(e) => {
//                     e.preventDefault();
//                   }}
//                 >
//                   Checkout
//                 </a>
//               </div>
//             </div>
//           </div>
//         </section>

//         <section className="checkout-page section-padding">
//           <div className="container">
//             {isLoaded ? (
//               <div>
//                 <Loading loading loaderColor="#f55d2c" />
//               </div>
//             ) : null}
//             <div className="row">
//               <div className="col-md-8">
//                 <div className="checkout-step">
//                   <div className="accordion" id="accordionExample">
//                     <div className="card checkout-step-one">
//                       <div className="card-header" id="headingOne">
//                         <h5 className="mb-0">
//                           <button
//                             className="btn btn-link checkout-login-bk"
//                             disabled
//                           >
//                             <span className="number">1</span> Login{" "}
//                             <span className="mdi mdi-checkbox-marked-circle-outline"></span>
//                           </button>
//                           <div className="_2jDL7w">
//                             <div>
//                               <span className="dNZmcB">
//                                 {customer.firstName}
//                               </span>
//                               <span className="_3MeY5j">{email}</span>
//                             </div>
//                           </div>
//                         </h5>
//                       </div>
//                     </div>

//                     {/* Step 2: Delivery Address */}
//                     {currentStep >= 2 && (
//                       <div className="card checkout-step-two">
//                         <div className="card-header" id="headingTwo">
//                           <h5 className="mb-0">
//                             <button
//                               className="btn btn-link collapsed"
//                               type="button"
//                               data-toggle="collapse"
//                               data-target="#collapseTwo"
//                               aria-expanded="false"
//                               aria-controls="collapseTwo"
//                             >
//                               <span className="number">2</span> Billing Address
//                             </button>
//                           </h5>
//                         </div>
//                         <div
//                           id="collapseTwo"
//                           className="collapse show"
//                           aria-labelledby="headingTwo"
//                           data-parent="#accordionExample"
//                         >
//                           <Addressdetails
//                             onSelectDeliveryAddress={this.handleDeliveryAddress}
//                           />
//                         </div>
//                       </div>
//                     )}

//                     {/* Step 3: Payment */}
//                     {currentStep >= 3 && (
//                       <div className="card">
//                         <div className="card-header" id="headingThree">
//                           <h5 className="mb-0">
//                             <button
//                               className="btn btn-link collapsed"
//                               type="button"
//                               data-toggle="collapse"
//                               data-target="#collapseThree"
//                               aria-expanded="false"
//                               aria-controls="collapseThree"
//                             >
//                               <span className="number">3</span> Payment
//                             </button>
//                           </h5>
//                         </div>
//                         <div
//                           id="collapseThree"
//                           className="collapse show"
//                           aria-labelledby="headingThree"
//                           data-parent="#accordionExample"
//                         >
//                           <div className="checkout-step-body">
//                             <div className="payment_method-checkout">
//                               <div className="row">
//                                 <div className="col-md-12">
//                                   <button
//                                     className="next-btn16 hover-btn"
//                                     onClick={this.handlePaymentSystem}
//                                   >
//                                     Confirm Order
//                                   </button>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>

//               <div className="col-md-4">
//                 <div className="checkout-summary">
//                   <h3>Cart Summary</h3>
//                   {cartItems.map((row, index) => (
//                     <div className="card-body pt-0 pr-0 pl-0 pb-0" key={index}>
//                       <div className="cart-list-product">
//                         <img
//                           crossOrigin="anonymous"
//                           className="img-fluid"
//                           src={row.photo}
//                           alt="cart"
//                         />
//                         <h5>{row.name}</h5>
//                         <div className="cart-radio">
//                           {row.selectedVariants &&
//                             row.selectedVariants.map((machine) => (
//                               <div
//                                 key={machine.id}
//                                 className="d-flex align-items-center justify-content-between"
//                               >
//                                 <span>
//                                   {machine.name} (₹{machine.price})
//                                 </span>
//                               </div>
//                             ))}
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                   <div className="total-checkout-group">
//                     <div className="cart-total-dil">
//                       <h4>Sub Total</h4>
//                       <span>&#x20B9;{subTotal.toFixed(2)}</span>
//                     </div>
//                   </div>
//                   <div className="total-checkout-group">
//                     <div className="cart-total-dil">
//                       <h4>Discount</h4>
//                       <span>-&#x20B9;{discount.toFixed(2)}</span>
//                     </div>
//                   </div>
//                   <div className="main-total-cart mt-3">
//                     <h2>Total</h2>
//                     <span>&#x20B9;{total.toFixed(2)}</span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//       </div>
//     );
//   }
// }

// const mapStateToProps = (state) => ({
//   cartItems: state.cart.cartItems,
// });

// export default connect(mapStateToProps, {
//   removeFromCart,
//   incrementToCart,
//   decreaseToCart,
// })(Checkout);

// HDFC Payment

import React, { Component } from "react";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import { GetUserLogin, GetWalletDetails } from "../../../services";
import {
  removeFromCart,
  incrementToCart,
  decreaseToCart,
  clearCart,
} from "../../../../store/actions/cartActions";
import Addressdetails from "./address";
import Loading from "react-fullscreen-loading";
import ApiClient from "../../../../utils/ApiClient";
import "./checkout.css";

class Checkout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      subTotal: 0,
      discount: 0,
      deliveryCharge: 0,
      grandTotal: 0,
      email: "",
      customer: "",
      deliveryAddress: "",
      currentStep: 1,
      orderId: null,
      paymentProcessing: false, // prevent multiple clicks
      iframeUrl: "",
      wallet: null,
      walletLoading: true,
      showWalletModal: false,
      showConfirmWalletModal: false,
      requiredAmount: 0,
      remainingBalance: 0,
    };
    this.paymentWindow = null;
  }

  handleDeliveryAddress = (value) => {
    this.setState({ deliveryAddress: value, currentStep: 3 });
  };

  async componentDidMount() {
    if (!this.props.cartItems || this.props.cartItems.length === 0) {
      window.location.href = "/";
      return;
    }

    let email = sessionStorage.getItem("email");
    if (email) {
      let user = await GetUserLogin.getCustomerDetail(email);
      if (user) {
        this.setState(
          { customer: user.data, email: email, currentStep: 2 },
          () => {
            this.fetchWallet(user.data.id);
          },
        );
      }
    }

    const subTotal = this.calculateSubTotal();
    const discount = subTotal > 100 ? subTotal * 0.1 : 0;
    const deliveryCharge = subTotal * 0.05;
    const grandTotal = subTotal - discount + deliveryCharge;

    this.setState({ subTotal, discount, deliveryCharge, grandTotal });
  }

  openInsufficientWalletModal = () => {
    const { wallet } = this.state;

    // Use discounted final amount
    const total = this.calculateFinalTotal();

    const requiredAmount = total - (wallet?.balance || 0);

    this.setState({
      showWalletModal: true,
      requiredAmount,
    });
  };

  openConfirmWalletModal = () => {
    const { wallet } = this.state;

    // Use discounted final amount
    const total = this.calculateFinalTotal();

    const remainingBalance = wallet.balance - total;

    this.setState({
      showConfirmWalletModal: true,
      remainingBalance,
    });
  };

  fetchWallet = async (custId) => {
    try {
      const res = await GetWalletDetails.getWalletByCustomerId(custId);

      this.setState({
        wallet: res?.data || null,
        walletLoading: false,
      });
    } catch (err) {
      this.setState({
        wallet: null,
        walletLoading: false,
      });
    }
  };

  calculateSubTotal = () => {
    return this.props.cartItems.reduce((sum, item) => {
      if (Array.isArray(item.selectedVariants)) {
        return (
          sum +
          item.selectedVariants.reduce(
            (variantSum, variant) =>
              variantSum +
              (typeof variant.price === "number" ? variant.price : 0),
            0,
          )
        );
      }
      return sum;
    }, 0);
  };

  prepareProducts = (cartItems) => {
    return cartItems.map((item) => ({
      productId: item.id,
      variantIds: item.selectedVariants.map((variant) => variant.id),
    }));
  };

  /** 🔑 Initiate HDFC payment */
  handleHdfcPayment = async (e) => {
    e.preventDefault();

    const { paymentProcessing, customer, deliveryAddress } = this.state;
    const { cartItems } = this.props;

    if (paymentProcessing) return; // ✅ prevent multiple clicks

    if (!deliveryAddress) {
      NotificationManager.error("Please select a delivery address", "Error");
      return;
    }

    this.setState({ paymentProcessing: true, isLoaded: true });

    try {
      const payload = {
        custId: customer.id,
        custEmail: customer.email,
        custPhone: customer.phone,
        cartItems,
        products: this.prepareProducts(cartItems),
        addressId: deliveryAddress.selectedAddress || null,
        deliveryAddress,
      };

      const response = await ApiClient.sendPostRequest(
        "https://jccreations.boutique/api/order/webhdfcorder",
        payload,
      );

      const iframeUrl = response?.sdk_payload?.payment_links?.web;
      const orderId = response?.orderId;

      if (!iframeUrl || !orderId) throw new Error("Payment initiation failed");

      clearCart();

      // ✅ Open HDFC payment in same tab
      window.location.href = iframeUrl;
    } catch (error) {
      console.error("HDFC Payment Error:", error);
      NotificationManager.error(
        error.message || "Payment initialization failed",
      );
      this.setState({ paymentProcessing: false, isLoaded: false });
    }
  };

  calculateDiscount = () => {
    const subTotal = this.calculateSubTotal();
    return subTotal > 100 ? subTotal * 0.1 : 0;
  };

  calculateFinalTotal = () => {
    const subTotal = this.calculateSubTotal();
    const discount = this.calculateDiscount();
    const deliveryCharge = 0; // currently you are using 0 in render

    return subTotal - discount + deliveryCharge;
  };

  handleWalletPayment = async () => {
    const { customer, wallet, deliveryAddress } = this.state;
    const { cartItems } = this.props;

    // IMPORTANT: use discounted final amount
    const total = this.calculateFinalTotal();

    if (!wallet || wallet.balance < total) {
      NotificationManager.error(
        `Insufficient wallet balance. Required: ₹${total.toFixed(2)}`,
        "Error",
      );
      return;
    }

    this.setState({ paymentProcessing: true, isLoaded: true });

    try {
      const payload = {
        custId: customer.id,
        cartItems,
        products: this.prepareProducts(cartItems),
        addressId: deliveryAddress.selectedAddress || null,
        deliveryAddress,

        // IMPORTANT: send discounted amount to backend
        amount: total,
        totalAmount: total,
        discount: this.calculateDiscount(),
      };

      const res = await GetWalletDetails.getDebitWalletbyCustomer(payload);

      if (res?.success) {
        clearCart();

        NotificationManager.success("Payment successful via Wallet", "Success");

        window.location.href = "/account/order/list";
      } else {
        throw new Error("Wallet debit failed");
      }
    } catch (err) {
      NotificationManager.error(
        err.message || "Wallet payment failed",
        "Error",
      );

      this.setState({
        paymentProcessing: false,
        isLoaded: false,
      });
    }
  };

  /** 🔑 Open payment popup and monitor close */
  openPaymentWindow = (iframeUrl, orderId) => {
    if (this.paymentWindow && !this.paymentWindow.closed) {
      this.paymentWindow.focus();
      return;
    }

    this.paymentWindow = window.open(
      iframeUrl,
      "HDFC Payment",
      "width=800,height=600,scrollbars=yes,resizable=yes",
    );

    const checkPopupClosed = setInterval(async () => {
      if (!this.paymentWindow || this.paymentWindow.closed) {
        clearInterval(checkPopupClosed);

        // Make one backend call to finalize order
        try {
          const res = await ApiClient.get(
            `https://jccreations.boutique/api/order/webhdfcresponse?order_id=${orderId}`,
          );

          if (res.success) {
            NotificationManager.success("Payment successful!", "Success");
            window.location.href = "/account/order/list";
          } else {
            NotificationManager.error(
              "Payment failed or could not finalize order",
              "Error",
            );
            window.location.href = "/order/failed";
          }
        } catch (err) {
          console.error(err);
          NotificationManager.error("Error finalizing order", "Error");
          window.location.href = "/order/failed";
        }
      }
    }, 2000); // Only check popup close, not status continuously
  };

  render() {
    const { cartItems } = this.props;
    const {
      discount,
      email,
      customer,
      currentStep,
      isLoaded,
      subTotal,
      paymentProcessing,
    } = this.state;

    const deliveryCharges = subTotal * 0.0;

    const total = subTotal - discount + deliveryCharges;

    return (
      <div>
        <section className="pt-3 pb-3 page-info section-padding border-bottom bg-white single-product-header-bk">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <a href="/">
                  <strong>
                    <span className="mdi mdi-home"></span> Home
                  </strong>
                </a>
                <span className="mdi mdi-chevron-right"></span>
                <a href="/" onClick={(e) => e.preventDefault()}>
                  Checkout
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="checkout-page section-padding">
          <div className="container">
            {isLoaded && <Loading loading loaderColor="#f55d2c" />}
            <div className="row">
              <div className="col-md-8">
                <div className="checkout-step">
                  <div className="accordion" id="accordionExample">
                    {/* Step 1: Login */}
                    <div className="card checkout-step-one">
                      <div className="card-header" id="headingOne">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link checkout-login-bk"
                            disabled
                          >
                            <span className="number">1</span> Login{" "}
                            <span className="mdi mdi-checkbox-marked-circle-outline"></span>
                          </button>
                          <div className="_2jDL7w">
                            <div>
                              <span className="dNZmcB">
                                {customer.firstName}
                              </span>
                              <span className="_3MeY5j">{email}</span>
                            </div>
                          </div>
                        </h5>
                      </div>
                    </div>

                    {/* Step 2: Delivery Address */}
                    {currentStep >= 2 && (
                      <div className="card checkout-step-two">
                        <div className="card-header" id="headingTwo">
                          <h5 className="mb-0">
                            <button
                              className="btn btn-link collapsed"
                              type="button"
                              data-toggle="collapse"
                              data-target="#collapseTwo"
                            >
                              <span className="number">2</span> Billing Address
                            </button>
                          </h5>
                        </div>
                        <div id="collapseTwo" className="collapse show">
                          <Addressdetails
                            onSelectDeliveryAddress={this.handleDeliveryAddress}
                          />
                        </div>
                      </div>
                    )}

                    {/* Step 3: Payment */}
                    {currentStep >= 3 && (
                      <div className="card">
                        <div className="card-header" id="headingThree">
                          <h5 className="mb-0">
                            <button
                              className="btn btn-link collapsed"
                              type="button"
                            >
                              <span className="number">3</span> Payment
                            </button>
                          </h5>
                        </div>
                        <div id="collapseThree" className="collapse show">
                          <div className="checkout-step-body">
                            {/* 🔥 Wallet Section */}
                            {this.state.walletLoading ? (
                              <p>Loading wallet...</p>
                            ) : !this.state.wallet ? (
                              <div className="mb-3">
                                <p>No wallet found.</p>
                                <button
                                  className="next-btn16 hover-btn"
                                  onClick={() =>
                                    (window.location.href = "/account/wallet")
                                  }
                                >
                                  Activate Wallet
                                </button>
                              </div>
                            ) : (
                              <div className="mb-3">
                                <p>
                                  <strong>Wallet Balance:</strong> ₹
                                  {this.state.wallet.balance}
                                </p>

                                {/* <button
                                  className="next-btn16 hover-btn mb-2"
                                  onClick={this.handleWalletPayment}
                                  disabled={
                                    this.state.wallet.balance < total ||
                                    paymentProcessing
                                  }
                                >
                                  {this.state.wallet.balance < total
                                    ? "Insufficient Wallet Balance"
                                    : "Pay with Wallet"}
                                </button> */}

                                <button
                                  className="next-btn16 hover-btn mb-2"
                                  onClick={
                                    this.state.wallet.balance < total
                                      ? this.openInsufficientWalletModal
                                      : this.openConfirmWalletModal
                                  }
                                  disabled={paymentProcessing}
                                >
                                  {this.state.wallet.balance < total
                                    ? "Pay With Wallet"
                                    : "Pay with Wallet"}
                                </button>

                                <hr />
                                <p className="text-center">OR</p>
                              </div>
                            )}
                            <button
                              className="next-btn16 hover-btn"
                              onClick={this.handleHdfcPayment}
                              disabled={paymentProcessing} // prevent multiple clicks
                            >
                              {paymentProcessing
                                ? "Processing..."
                                : "Pay via UPI / Card"}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Cart Summary */}
              <div className="col-md-4">
                <div className="checkout-summary">
                  <h3>Cart Summary</h3>
                  {cartItems.map((row, index) => (
                    <div className="card-body pt-0 pr-0 pl-0 pb-0" key={index}>
                      <div className="cart-list-product">
                        <img
                          crossOrigin="anonymous"
                          className="img-fluid"
                          src={row.photo}
                          alt="cart"
                        />
                        <h5>{row.name}</h5>
                        <div className="cart-radio">
                          {row.selectedVariants &&
                            row.selectedVariants.map((machine) => (
                              <div key={machine.id}>
                                <span>
                                  {machine.name} (₹{machine.price})
                                </span>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  ))}
                  <div className="total-checkout-group">
                    <div className="cart-total-dil">
                      <h4>Sub Total</h4>
                      <span>&#x20B9;{subTotal.toFixed(2)}</span>
                    </div>
                  </div>
                  <div className="total-checkout-group">
                    {/* revert back */}
                    {/* <div className="cart-total-dil">
                      <h4>Discount</h4>
                      <span>-&#x20B9;{discount.toFixed(2)}</span>
                    </div> */}
                    {/* revert back */}
                  </div>
                  <div className="main-total-cart">
                    <h2>Total</h2>
                    <span>&#x20B9;{total.toFixed(2)}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {this.state.showWalletModal && (
          <div className="wallet-modal-overlay">
            <div className="wallet-modal">
              <h3>Insufficient Wallet Balance</h3>
              <p>
                You need ₹{this.state.requiredAmount.toFixed(2)} more to
                complete this purchase.
              </p>
              <div className="wallet-modal-actions">
                <button
                  className="btn btn-secondary"
                  onClick={() => this.setState({ showWalletModal: false })}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => (window.location.href = "/account/wallet")}
                >
                  Recharge Wallet
                </button>
              </div>
            </div>
          </div>
        )}

        {this.state.showConfirmWalletModal && (
          <div className="wallet-modal-overlay">
            <div className="wallet-modal">
              <h3>Confirm Wallet Payment</h3>
              <p>
                After payment, your remaining wallet balance will be{" "}
                <strong>₹{this.state.remainingBalance.toFixed(2)}</strong>
              </p>
              <div className="wallet-modal-actions">
                <button
                  className="btn btn-secondary"
                  onClick={() =>
                    this.setState({ showConfirmWalletModal: false })
                  }
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    this.setState({ showConfirmWalletModal: false });
                    this.handleWalletPayment();
                  }}
                >
                  Confirm Payment
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  cartItems: state.cart.cartItems,
});

export default connect(mapStateToProps, {
  removeFromCart,
  incrementToCart,
  decreaseToCart,
  clearCart,
})(Checkout);
